<template>
    <div class="teams-date-picker relative">
        <FlatPickrWrapper v-model:show="expanded" :value="modelValue" auto-width class="h-full" :show-overlay="false" :config="config" @update:value="onChange">
            <button
                :class="[expanded ? 'bg-white border-black' : 'bg-transparent border-gray-200', 'h-full py-2 px-3']"
                class="text-left flex text-base text-dark-gray-600 content-center border-solid border rounded-md"
                @click.prevent="expanded = !expanded"
            >
                <div class="flex h-full whitespace-nowrap text-normal">
                    <span v-if="prefix" class="font-semibold my-auto mr-1">{{ prefix }}:</span>
                    <span class="my-auto w-auto">
                        {{ displayValue }}
                    </span>
                    <span class="h-full flex items-center my-auto ml-2">
                        <ChevronDown class="size-5 -mr-1 transform transition-transform" :class="{ 'rotate-[180deg]': expanded }" />
                    </span>
                </div>
            </button>
        </FlatPickrWrapper>
    </div>
</template>

<script setup lang="ts">
import { ChevronDown } from 'lucide-vue-next';
import { computed, ref } from 'vue';
import FlatPickrWrapper from '@/components/ui/FlatpickrWrapper.vue';
import { i18n } from '@/plugins/internationalization/i18n';

interface Props {
    prefix?: string;
    config?: Record<string, any>;
}

defineProps<Props>();

const modelValue = defineModel<string>('modelValue', { required: true });

const displayValue = computed(() => i18n.global.d(new Date(Date.parse(modelValue.value)), 'short'));

const expanded = ref(false);

function onChange(newValue: string) {
    modelValue.value = newValue || new Date().toISOString();
}
</script>

<style>
.teams-date-picker .flatpickr-wrapper {
    top: 1.1rem;
}
</style>
